import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const skillsBlockFields = `
  _id,
  _type,
  title,
  showTitle,
  subTitle,
  backgroundColor,
  items[]{
    title,
    description,
    image {
      ${imageFields}
    }
  }
`

export const SKILLS_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "skills-block"][0]{
    ${skillsBlockFields}
  }
`)
